import { NATIVE_APPROVAL_TYPES, NATIVE_VIEW_APPROVAL_TYPES } from '@/constant';

/** 레거시 인트라넷 화면이 쓰던 기존 채널. v2 미이관 양식은 계속 이쪽 */
export const APPROVAL_TAB_LEGACY = 'approval';
/**
 * 포탈 화면을 여는 채널. 앱이 뒤로가기를 직접 그려주는 기존 채널을 그대로 씀
 * (앱 담당 확인). 웹은 헤더를 그리지 않음 — 그리면 뒤로가기가 두 개가 됨.
 */
export const APPROVAL_TAB_PORTAL = 'board';

/**
 * 이 양식의 작성이 v2 로 이관됐는지. 작성 URL 을 고를 때만 쓸 것.
 * 채널 고르는 데 쓰면 양식 코드를 모르는 진입(최근 본 문서)에서 답이 안 나옴.
 */
export const isNativeApprovalType = (apvType?: number): boolean =>
  typeof apvType === 'number' && NATIVE_APPROVAL_TYPES.includes(apvType);

/** 이 양식의 조회가 v2 인지. 조회 URL·조회 호스트(native/iframe) 판정에만 쓸 것 — 조회전용 유형 포함. */
export const isNativeViewApprovalType = (apvType?: number): boolean =>
  typeof apvType === 'number' && NATIVE_VIEW_APPROVAL_TYPES.includes(apvType);

/** 포탈이 그리는 화면인지. 채널 선택과 토큰 부착이 같은 기준을 쓰도록 여기 한 곳에 둠 */
export const isPortalHostedUrl = (url: string): boolean => {
  const origin = process.env.NEXT_PUBLIC_ORIGIN_URL;
  return Boolean(origin) && url.startsWith(origin as string);
};

/**
 * MOVE_TAB 에 실을 tabName. 기준은 "어떤 양식이냐"가 아니라 "화면을 누가 그리냐".
 *
 * 양식이 v2 인지는 URL 을 만들 때 이미 반영됨(getApprovalViewUrlByType 등).
 * 양식 코드 없이 포탈 뷰어로 보내는 진입도 뷰어가 조회 후 v2/iframe 을 알아서 고름.
 * 그래서 완성된 URL 만 보면 채널이 정해짐.
 */
export const getApprovalAppTabName = (url: string): string =>
  isPortalHostedUrl(url) ? APPROVAL_TAB_PORTAL : APPROVAL_TAB_LEGACY;
